import React, { createContext, useState, useEffect } from 'react';
import { SecureStorage } from '../Utilities/StorageEncryption';
const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(SecureStorage.getItem("theme") || "light");

  const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
  ? "dark"
  : "light";

  const toggleTheme = (newTheme) => {
    setTheme(newTheme);
    SecureStorage.setItem("theme", newTheme); // Persist theme in SecureStorage
  };

  useEffect(() => {
    const loadThemeCSS = async () => {
      if (theme === "dark") {
        await import('mdb-react-ui-kit/dist/css/mdb.dark.min.css');
        await import("./../styles/dark.css");
      } else if (theme === "high-contrast") {
        await import('mdb-react-ui-kit/dist/css/mdb.dark.min.css');
        await import("./../styles/highcontrast.css");
      } else if (theme === "OS-theme") {
        if (systemTheme === "dark" ) {
          await import('mdb-react-ui-kit/dist/css/mdb.dark.min.css');
          await import("./../styles/dark.css");
        } else {
          await import("./../styles/light.css");
        }
      } else {
        await import("./../styles/light.css");
      }
    };
    loadThemeCSS();
  }, [theme]);

  // Value to be provided to consuming components
  const contextValue = {
    theme,
    setTheme: toggleTheme,
  };

  return <ThemeContext.Provider value={contextValue}>{children}</ThemeContext.Provider>;
};

export { ThemeContext, ThemeProvider };
